var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOutletIcon6({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 33,
    viewBox: "0 0 22 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.4504,
    cy: 12.05,
    r: 6.05,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 1C16.8302 1 21.5 5.40243 21.5 10.7539C21.4999 12.9392 20.8386 15.3614 19.8203 17.7871C18.804 20.2081 17.4444 22.6025 16.0791 24.7236C14.7146 26.8435 13.3497 28.6825 12.3252 29.9912C11.8131 30.6453 11.3867 31.1665 11.0889 31.5234C11.0581 31.5603 11.0279 31.5946 11 31.6279C10.9721 31.5946 10.9419 31.5603 10.9111 31.5234C10.6133 31.1665 10.1869 30.6453 9.6748 29.9912C8.65027 28.6825 7.28542 26.8435 5.9209 24.7236C4.55556 22.6025 3.19601 20.2081 2.17969 17.7871C1.16145 15.3614 0.500067 12.9392 0.5 10.7539C0.5 5.40243 5.1698 1 11 1ZM12.8809 7.22266C11.9835 6.83773 10.9949 6.73714 10.041 6.93359C9.08717 7.1301 8.21335 7.6148 7.5293 8.32324C6.84547 9.03149 6.38116 9.93163 6.19336 10.9092C6.00562 11.8867 6.10206 12.9004 6.4707 13.8223C6.83938 14.7441 7.46478 15.535 8.27051 16.0928C9.07669 16.6507 10.0269 16.9502 11 16.9502H11.001C12.3056 16.9486 13.5528 16.4106 14.4697 15.4609C15.3861 14.5118 15.8989 13.2285 15.9004 11.8936V11.8926C15.9003 10.8963 15.6152 9.92086 15.0791 9.08984C14.5428 8.25855 13.7782 7.6076 12.8809 7.22266Z",
    fill: "#1E49B9",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.66028 14.9135L14.2574 10.2445C14.4691 10.0296 14.8157 10.0296 15.0274 10.2445C15.2344 10.4548 15.2344 10.7923 15.0274 11.0026L9.66028 16.4535L6.97381 13.7251C6.76675 13.5148 6.76675 13.1773 6.97381 12.967C7.18545 12.752 7.5321 12.752 7.74374 12.967L9.66028 14.9135Z",
    fill: "#1E49B9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutletIcon6);
export default __webpack_public_path__ + "static/media/OutletIcon6.e7628038b6fa81552ffae18edd6201f7.svg";
export { ForwardRef as ReactComponent };